
export type HeroClass = "Warrior" | "Mage"  | "Ranger" | "Assassin" | "Priest";
export type HeroFaction = "Shadow" | "Fortress" | "Abyss" | "Forest" | "Dark" | "Light" | "Transcendence";

export interface HeroData {
    faction: HeroFaction;
    class: HeroClass;
    stars: number[];
    elite: boolean;
    imprint: boolean;
    class_supplement?: HeroClass;
    tenants?: {
        1: string[],
        2: string[],
        3: string[],
        4: string[],
    };
    tenant?: boolean;
    short?: string;
}

export interface  HeroesData {
    [details: string] : HeroData;
}

//
// hero: 140x140 (25)
// shard: 158x158 (25)

/*
 * [x] Star-devouring Bloom - Madeleine
 * [x] Madeleine
 * [x] Ironcore Mecha - Basilisk
 * [x] Basilisk
 * [x] Weaver of Life - Ignacia
 * [x] Ignacia
 * [x] Stygian Twilight - Vespera
 * [x] Vespera
 * [x] Cosmic Speedster - Sylvie
 * [x] Sylvie
 * [x] Count of Nightmare - Finn
 * [x] Finn
 * [x] Great Sage - Sun Wukong
 * [x] Monkey King - Sun Wukong
 * [x] King of Abysmal Sea - Norton Haig
 * [x] Norton Haig
 * [x] Roseheart Fanatic - Williams
 * [x] Williams
 * [x] Lady of Blossom Realm - Melissa
 * [x] Melissa
 * [x] Infinite Era - Alikita
 * [x] Alikita
 * [x] Cosmic Enforcer - Luna
 */

let _heroesData: HeroesData = {
    /* === Shadow ============================================================================================= */
    "Basilisk": {
        "faction": "Shadow",
        "class": "Ranger",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
             "1": ['Williams', 'Patricia'],
             "2": ['Finn', 'Betty', 'Madeleine'],
             "3": ['Melissa'],
             "4": ['Ignacia'],
        },
    },
    "Norton Haig": {
        "faction": "Shadow",
        "class": "Warrior",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
             "1": ['UniMax-3000', 'Xiahou', 'Ignacia'],
             "2": ['Luna', 'Annabelle', 'Finn'],
             "3": ['Gloria', 'Madeleine'],
             "4": ['Amen-Ra'],
        },
    },
    "Betty": {
        "faction": "Shadow",
        "class": "Mage",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
             "1": ['Annabelle', 'Holmes Young', 'Luna'],
             "2": ['Azrael', 'Patricia', 'Alikita'],
             "3": ['Onkirimaru','Melissa'],
             "4": ['Eos', 'Williams'],
        },
    },
    "Azrael": {
        "faction": "Shadow",
        "class": "Assassin",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
             "1": ['Tix', 'Ithaqua', 'Natalie'],
             "2": ['Eloise', 'Natasha', 'Geester'],
             "3": ['Onkirimaru', 'Saja', 'Betty'],
             "4": ['Annabelle', 'Tussilago', 'Yorhm Tum'],
        },
    },
    "Annabelle": {
        "faction": "Shadow",
        "class": "Priest",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Carrie', 'Eloise', 'Azrael'],
            "2": ['Waldeck', 'Drake', 'Aranea'],
            "3": ['Phorcys', 'Tix', 'Elena'],
            "4": ['Ithaqua', 'Gustin', 'Betty'],
       },
    },
    "Onkirimaru": {
        "faction": "Shadow",
        "class": "Warrior",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Eloise', 'Gustin', 'Annabelle'],
            "2": ['Tix', 'Nakia', 'Mockman'],
            "3": ['Jahra', 'Rogan', 'Azrael'],
            "4": ['Horus', 'Phorcys', 'Vulkan'],
       },
    },
    "Eloise": {
        "faction": "Shadow",
        "class": "Ranger",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Flora', 'Ithaqua', 'Onkirimaru'],
            "2": ['Gustin', 'Jahra', 'Saja'],
            "3": ['Tix', 'Mihm', 'Annabelle'],
            "4": ['Carrie', 'Amen-Ra', 'Freya'],
       },
    },
    "Tix": {
        "faction": "Shadow",
        "class": "Mage",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Gustin', 'Corpsedemon', 'Onkirimaru'],
            "2": ['Ithaqua', 'Baade', 'Annabelle'],
            "3": ['Phorcys', 'Carrie', 'Holmes Young'],
            "4": ['Eloise', 'Mihm', 'Azrael'],
       },
    },
    "Ithaqua": {
        "faction": "Shadow",
        "class": "Assassin",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Phorcys', 'Baade', 'Aidan'],
            "2": ['Tix', 'Drake', 'Lutz'],
            "3": ['Eloise', 'Gustin', 'Kamath'],
            "4": ['Delacium', 'Amen-Ra', 'Onkirimaru'],
       },
    },
    "Gustin": {
        "faction": "Shadow",
        "class": "Priest",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Baade', 'King Barton', 'Karim'],
            "2": ['Faceless', 'Field', 'Flame Strike'],
            "3": ['Aidan', 'Dominator', 'Corpsedemon'],
            "4": ['Kamath', 'Amuvor', 'Das Moge'],
       },
    },
    "Horus": {
        "faction": "Shadow",
        "class": "Warrior",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Kamath', 'Amuvor', 'Dark Arthindol'],
            "2": ['Delacium', 'Corpsedemon', 'Aspen'],
            "3": ['Ithaqua', 'Jahra', 'Blood Blade'],
            "4": ['Drake', 'Sleepless', 'Walter'],
       },
    },
    "Jahra": {
        "faction": "Shadow",
        "class": "Mage",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
    },
    "Kamath": {
        "faction": "Shadow",
        "class": "Ranger",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
    },
    "Corpsedemon": {
        "faction": "Shadow",
        "class": "Warrior",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
    },
    "Blood Blade": {
        "faction": "Shadow",
        "class": "Assassin",
        "stars": [5, 6, 9, 10],
        "elite": false,
        "imprint": false,
    },
    "Walter": {
        "faction": "Shadow",
        "class": "Assassin",
        "stars": [5, 6, 9, 10],
        "elite": false,
        "imprint": false,
    },
    "Field": {
        "faction": "Shadow",
        "class": "Ranger",
        "stars": [5, 6, 9, 10],
        "elite": false,
        "imprint": false,
    },
    "Kharma": {
        "faction": "Shadow",
        "class": "Priest",
        "stars": [5, 6, 9, 10],
        "elite": false,
        "imprint": false,
    },
    "Aidan": {
        "faction": "Shadow",
        "class": "Mage",
        "stars": [5, 6, 9, 10],
        "elite": false,
        "imprint": false,
    },
    "Baade": {
        "faction": "Shadow",
        "class": "Warrior",
        "stars": [5, 6, 9, 10],
        "elite": false,
        "imprint": false,
    },
    "Lutz": {
        "faction": "Shadow",
        "class": "Assassin",
        "stars": [5, 6, 9, 10],
        "elite": false,
        "imprint": false,
    },
    "Dominator": {
        "faction": "Shadow",
        "class": "Warrior",
        "stars": [5, 6, 9, 10],
        "elite": false,
        "imprint": false,
    },
    "Glen": {
        "faction": "Shadow",
        "class": "Priest",
        "stars": [4, 5, 6, 9],
        "elite": false,
        "imprint": false,
    },
    "Bonecarver": {
        "faction": "Shadow",
        "class": "Assassin",
        "stars": [4, 5, 6, 9],
        "elite": false,
        "imprint": false,
    },
    "Deathsworn": {
        "faction": "Shadow",
        "class": "Mage",
        "stars": [4, 5, 6, 9],
        "elite": false,
        "imprint": false,
    },
    "Lamb": {
        "faction": "Shadow",
        "class": "Ranger",
        "stars": [4, 5],
        "elite": false,
        "imprint": false,
    },
    "Bone General": {
        "faction": "Shadow",
        "class": "Warrior",
        "stars": [4, 5],
        "elite": false,
        "imprint": false,
    },
    "Nightmare Knight": {
        "faction": "Shadow",
        "class": "Warrior",
        "stars": [4, 5],
        "elite": false,
        "imprint": false,
    },
    "Gbagbo": {
        "faction": "Shadow",
        "class": "Ranger",
        "stars": [4, 5],
        "elite": false,
        "imprint": false,
    },
    "Grumpy Corpse": {
        "faction": "Shadow",
        "class": "Warrior",
        "stars": [4, 5],
        "elite": false,
        "imprint": false,
    },  
    /* === Fortress ============================================================================================= */
    "Madeleine": {
        "faction": "Fortress",
        "class": "Priest",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
             "1": ['Vespera', 'Melissa'],
             "2": ['Monkey King - Sun Wukong', 'Luna'],
             "3": ['Yorhm Tum'],
             "4": ['Freya'],
        },
    },
    "Finn": {
        "faction": "Fortress",
        "class": "Assassin",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
             "1": ['Onkirimaru', 'Drake', 'Vespera'],
             "2": ['Williams', 'Saja', 'Sylvie'],
             "3": ['Aranea'],
             "4": ['Geester'],
        },
    },
    "Luna": {
        "faction": "Fortress",
        "class": "Assassin",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Yorhm Tum', 'Natasha', 'Monkey King - Sun Wukong'],
            "2": ['Patricia', 'Saja', 'Williams'],
            "3": ['Holmes Young', 'Finn'],
            "4": ['Tussilago', 'Sylvie'],
       },
    },
    "Aylamak": {
        "faction": "Fortress",
        "class": "Warrior",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Holmes Young', 'Vulkan', 'Gaggie'],
            "2": ['Saja', 'Mockman', 'Luna'],
            "3": ['Fiona', 'Onkirimaru', 'Basilisk'],
            "4": ['Sherlock', 'Xiahou', 'Madeleine'],
       },
    },
    "Holmes Young": {
        "faction": "Fortress",
        "class": "Mage",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Fiona', 'Gloria', 'Eos'],
            "2": ['Saja', 'Natasha', 'Elena'],
            "3": ['Inosuke', 'Phorcys', 'Geester'],
            "4": ['Xiahou', 'Sherlock', 'Aylamak'],
       },
    },
    "Saja": {
        "faction": "Fortress",
        "class": "Assassin",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Inosuke', 'Xia', 'Natasha'],
            "2": ['Fiona', 'Penny', 'Holmes Young'],
            "3": ['Rogan', 'Waldeck', 'Azrael'],
            "4": ['Sherlock', 'UniMax-3000', 'Freya'],
       },
    },
    "Fiona": {
        "faction": "Fortress",
        "class": "Priest",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Andrea', 'Inosuke', 'Saja'],
            "2": ['Ignis', 'UniMax-3000', 'Eos'],
            "3": ['Tussilago', 'Penny', 'Holmes Young'],
            "4": ['Russell', 'Sherlock', 'Elena'],
       },
    },
    "Inosuke": {
        "faction": "Fortress",
        "class": "Ranger",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Elyvia', 'Xia', 'Saja'],
            "2": ['Rogan', 'UniMax-3000', 'Holmes Young'],
            "3": ['Fiona', 'Miki', 'Freya'],
            "4": ['Morax', 'Mirage', 'Mockman'],
       },
    },
    "Sherlock": {
        "faction": "Fortress",
        "class": "Mage",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Penny', 'Iceblink', 'Sigmund'],
            "2": ['Elyvia', 'Flame Strike', 'Honor Guard'],
            "3": ['Tix', 'Xia', 'Valentino'],
            "4": ['Fiona', 'Andrea', 'Saja'],
       },
    },
    "UniMax-3000": {
        "faction": "Fortress",
        "class": "Warrior",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Sigmund', 'OD-01', 'Emily'],
            "2": ['Flame Strike', 'Honor Guard', 'Bleecker'],
            "3": ['Penny', 'Asmodel', 'Baade'],
            "4": ['Iceblink', 'Eddga', 'Margaret'],
       },
    },
    "Penny": {
        "faction": "Fortress",
        "class": "Ranger",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Elyvia', 'Ormus', 'Gerke'],
            "2": ['Garuda', 'Honor Guard', 'Emily'],
            "3": ['Inosuke', 'Sigmund', 'Eddga'],
            "4": ['Sherlock', 'UniMax-3000', 'Skerei'],
       },
    },
    "Xia": {
        "faction": "Fortress",
        "class": "Assassin",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Sigmund', 'Bleecker', 'OD-01'],
            "2": ['Penny', 'Mirage', 'Honor Guard'],
            "3": ['Iceblink', 'Emily', 'Ormus'],
            "4": ['Blood Blade', 'Rosa', 'Faceless'],
       },
    },
    "Valentino": {
        "faction": "Fortress",
        "class": "Mage",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
    },
    "Sigmund": {
        "faction": "Fortress",
        "class": "Warrior",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
    },
    "Flame Strike": {
        "faction": "Fortress",
        "class": "Mage",
        "stars": [5, 6, 9, 10],
        "elite": false,
        "imprint": true,
    },
    "Emily": {
        "faction": "Fortress",
        "class": "Priest",
        "stars": [5, 6, 9, 10],
        "elite": false,
        "imprint": false,
    },
    "Ormus": {
        "faction": "Fortress",
        "class": "Priest",
        "stars": [5, 6, 9, 10],
        "elite": false,
        "imprint": false,
    },
    "OD-01": {
        "faction": "Fortress",
        "class": "Mage",
        "stars": [5, 6, 9, 10],
        "elite": false,
        "imprint": false,
    },
    "Miki": {
        "faction": "Fortress",
        "class": "Ranger",
        "stars": [5, 6, 9, 10],
        "elite": false,
        "imprint": false,
    },
    "Mirage": {
        "faction": "Fortress",
        "class": "Assassin",
        "stars": [5, 6, 9, 10],
        "elite": false,
        "imprint": false,
    },
    "Bleecker": {
        "faction": "Fortress",
        "class": "Mage",
        "stars": [5, 6, 9, 10],
        "elite": false,
        "imprint": false,
    },
    "Iceblink": {
        "faction": "Fortress",
        "class": "Ranger",
        "stars": [5, 6, 9, 10],
        "elite": false,
        "imprint": false,
    },
    "Honor Guard": {
        "faction": "Fortress",
        "class": "Warrior",
        "stars": [5, 6, 9, 10],
        "elite": false,
        "imprint": false,
    },
    "Kristian": {
        "faction": "Fortress",
        "class": "Warrior",
        "stars": [4, 5, 6, 9],
        "elite": false,
        "imprint": false,
    },
    "Roy": {
        "faction": "Fortress",
        "class": "Assassin",
        "stars": [4, 5, 6, 9],
        "elite": false,
        "imprint": false,
    },
    "Sierra": {
        "faction": "Fortress",
        "class": "Mage",
        "class_supplement": "Priest",
        "stars": [4, 5, 6, 9],
        "elite": false,
        "imprint": false,
    },
    "Iron Bambi": {
        "faction": "Fortress",
        "class": "Warrior",
        "stars": [4, 5],
        "elite": false,
        "imprint": false,
    },
    "LM-02": {
        "faction": "Fortress",
        "class": "Ranger",
        "stars": [4, 5],
        "elite": false,
        "imprint": false,
    },
    "Liquor": {
        "faction": "Fortress",
        "class": "Ranger",
        "stars": [4, 5],
        "elite": false,
        "imprint": false,
    },
    "Storm Huddle": {
        "faction": "Fortress",
        "class": "Warrior",
        "stars": [4, 5],
        "elite": false,
        "imprint": false,
    },
    "Time Mage": {
        "faction": "Fortress",
        "class": "Mage",
        "class_supplement": "Priest",
        "stars": [4, 5],
        "elite": false,
        "imprint": false,
    },
    /* === Abyss ============================================================================================= */
    "Ignacia": {
        "faction": "Abyss",
        "class": "Mage",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
             "1": ['Alikita', 'Eos'],
             "2": ['Yorhm Tum', 'Gaggie', 'Basilisk'],
             "3": ['Luna'],
             "4": ['Drake'],
        },
    },
    "Williams": {
        "faction": "Abyss",
        "class": "Ranger",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
             "1": ['Eloise', 'Carrie', 'Sylvie'],
             "2": ['Alikita', 'Morax', 'Monkey King - Sun Wukong'],
             "3": ['Fiona', 'Vespera'],
             "4": ['Freya', 'Ignacia'],
        },
    },
    "Gaggie": {
        "faction": "Abyss",
        "class": "Warrior",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
             "1": ['Vulkan', 'Mockman', 'Alikita'],
             "2": ['Aylamak', 'Waldeck', 'Melissa'],
             "3": ['Aranea', 'Williams'],
             "4": ['Natasha','Norton Haig'],
        },
    },
    "Aranea": {
        "faction": "Abyss",
        "class": "Priest",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
             "1": ['Ignis', 'Natasha', 'Elena'],
             "2": ['Morax', 'Delacium', 'Natalie'],
             "3": ['Annabelle', 'Fiona', 'Alikita'],
             "4": ['Waldeck', 'Amen-Ra', 'Melissa'],
        },
    },
    "Natasha": {
        "faction": "Abyss",
        "class": "Assassin",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Waldeck', 'Drake', 'Eos'],
            "2": ['Morax', 'Xiahou', 'Mockman'],
            "3": ['Ignis', 'Saja', 'Aranea'],
            "4": ['Delacium', 'Eloise', 'Gaggie'],
       },
    },
    "Waldeck": {
        "faction": "Abyss",
        "class": "Ranger",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Delacium', 'Cthugha', 'Natasha'],
            "2": ['Ignis', 'Onkirimaru', 'Aranea'],
            "3": ['Morax', 'Flora', 'Freya'],
            "4": ['Carrie', 'Nakia', 'Vulkan'],
       },
    },
    "Morax": {
        "faction": "Abyss",
        "class": "Warrior",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Ignis', 'Cthugha', 'Waldeck'],
            "2": ['Eloise', 'Barea', 'Natasha'],
            "3": ['Tussilago', 'Nakia', 'Aranea'],
            "4": ['Garuda', 'King Barton', 'Mockman'],
       },
    },
    "Ignis": {
        "faction": "Abyss",
        "class": "Priest",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Morax', 'Nakia', 'Waldeck'],
            "2": ['Cthugha', 'Kroos', 'Annabelle'],
            "3": ['Elyvia', 'Barea', 'Natasha'],
            "4": ['Delacium', 'Dantalian', 'Aranea'],
       },
    },
    "Delacium": {
        "faction": "Abyss",
        "class": "Mage",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Drake', 'Cthugha', 'Queen'],
            "2": ['Ignis', 'Kroos', 'Margaret'],
            "3": ['Morax', 'Nakia', 'Dantalian'],
            "4": ['Ithaqua', 'Dragon Slayer', 'Waldeck'],
       },
    },
    "Nakia": {
        "faction": "Abyss",
        "class": "Assassin",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Cthugha', 'Karim', 'Lutz'],
            "2": ['Kroos', 'Lord Balrog', 'Gusta'],
            "3": ['Margaret', 'Delacium', 'Xia'],
            "4": ['Barea', 'Dominator', 'Queen'],
       },
    },
    "Cthugha": {
        "faction": "Abyss",
        "class": "Ranger",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Barea', 'Delacium', 'Fat Mu'],
            "2": ['Kroos', 'Dantalian', 'Gusta'],
            "3": ['Nakia', 'King Barton', 'Queen'],
            "4": ['Skerei', 'Lord Balrog', 'Karim'],
       },
    },
    "King Barton": {
        "faction": "Abyss",
        "class": "Warrior",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
    },
    "Kroos": {
        "faction": "Abyss",
        "class": "Priest",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
    },
    "Skerei": {
        "faction": "Abyss",
        "class": "Mage",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": false,
    },
    "Barea": {
        "faction": "Abyss",
        "class": "Warrior",
        "stars": [5, 6, 9, 10],
        "elite": false,
        "imprint": false,
    },
    "Dantalian": {
        "faction": "Abyss",
        "class": "Warrior",
        "stars": [5, 6, 9, 10],
        "elite": false,
        "imprint": false,
    },
    "Karim": {
        "faction": "Abyss",
        "class": "Assassin",
        "stars": [5, 6, 9, 10],
        "elite": false,
        "imprint": false,
    },
    "Gusta": {
        "faction": "Abyss",
        "class": "Warrior",
        "stars": [5, 6, 9, 10],
        "elite": false,
        "imprint": false,
    },
    "Fat Mu": {
        "faction": "Abyss",
        "class": "Ranger",
        "stars": [5, 6, 9, 10],
        "elite": false,
        "imprint": false,
    },
    "Lord Balrog": {
        "faction": "Abyss",
        "class": "Warrior",
        "stars": [5, 6, 9, 10],
        "elite": false,
        "imprint": false,
    },
    "Queen": {
        "faction": "Abyss",
        "class": "Ranger",
        "stars": [5, 6, 9, 10],
        "elite": false,
        "imprint": true,
    },
    "Margaret": {
        "faction": "Abyss",
        "class": "Mage",
        "stars": [5, 6, 9, 10],
        "elite": false,
        "imprint": false,
    },
    "Destroyer": {
        "faction": "Abyss",
        "class": "Mage",
        "stars": [4, 5, 6, 9],
        "elite": false,
        "imprint": false,
    },
    "Aleria": {
        "faction": "Abyss",
        "class": "Mage",
        "stars": [4, 5, 6, 9],
        "elite": false,
        "imprint": false,
    },
    "Norma": {
        "faction": "Abyss",
        "class": "Priest",
        "stars": [4, 5, 6, 9],
        "elite": false,
        "imprint": false,
    },
    "Immolatus": {
        "faction": "Abyss",
        "class": "Warrior",
        "stars": [4, 5],
        "elite": false,
        "imprint": false,
    },
    "Lemegeton": {
        "faction": "Abyss",
        "class": "Warrior",
        "stars": [4, 5],
        "elite": false,
        "imprint": false,
    },
    "Akasha": {
        "faction": "Abyss",
        "class": "Assassin",
        "class_supplement": "Ranger",
        "stars": [4, 5],
        "elite": false,
        "imprint": false,
    },
    "Tanner": {
        "faction": "Abyss",
        "class": "Warrior",
        "stars": [4, 5],
        "elite": false,
        "imprint": false,
    },
    "Rogge": {
        "faction": "Abyss",
        "class": "Priest",
        "stars": [4, 5],
        "elite": false,
        "imprint": false,
    },
    /* === Forest ============================================================================================= */
    "Sylvie": {
        "faction": "Forest",
        "class": "Warrior",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
             "1": ['Norton Haig', 'Gaggie', 'Madeleine'],
             "2": ['Finn', 'Geester','Vespera'],
             "3": ['Patricia'],
             "4": ['Yorhm Tum'],
        },
    },
    "Melissa": {
        "faction": "Forest",
        "class": "Priest",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
             "1": ['Elena', 'Aranea', 'Finn'],
             "2": ['Gaggie', 'Xiahou', 'Norton Haig'],
             "3": ['Azrael', 'Ignacia'],
             "4": ['Andrea', 'Basilisk'],
        },
    },
    "Geester": {
        "faction": "Forest",
        "class": "Assassin",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
             "1": ['Rogan', 'Saja', 'Yorhm Tum'],
             "2": ['Aylamak', 'Patricia', 'Luna'],
             "3": ['Azrael', 'Natalie'],
             "4": ['Natasha', 'Alikita'],
        },
    },
    "Freya": {
        "faction": "Forest",
        "class": "Ranger",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
             "1": ['Gloria', 'Russell', 'Waldeck'],
             "2": ['Xiahou', 'Inosuke', 'Holmes Young'],
             "3": ['Rogan', 'Eloise', 'Patricia'],
             "4": ['Elyvia', 'Flora', 'Geester'],
        },
    },
    "Xiahou": {
        "faction": "Forest",
        "class": "Warrior",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Gloria', 'Garuda', 'Eos'],
            "2": ['Rogan', 'Saja', 'Freya'],
            "3": ['Elyvia', 'Andrea', 'Mockman'],
            "4": ['Onkirimaru', 'Fiona', 'Vulkan'],
       },
    },
    "Gloria": {
        "faction": "Forest",
        "class": "Mage",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Elyvia', 'Oberon', 'Xiahou'],
            "2": ['Garuda', 'Heart Watcher', 'Freya'],
            "3": ['Fiona', 'Valkyrie', 'Holmes Young'],
            "4": ['Eloise', 'Flora', 'Elena'],
       },
    },
    "Flora": {
        "faction": "Forest",
        "class": "Ranger",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Gloria', 'Heart Watcher', 'Xiahou'],
            "2": ['Elyvia', 'Vesa', 'Annabelle'],
            "3": ['Russell', 'Penny', 'Eos'],
            "4": ['Valkyrie', 'Rogan', 'Freya'],
       },
    },
    "Rogan": {
        "faction": "Forest",
        "class": "Assassin",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Flora', 'Gloria', 'Oberon'],
            "2": ['Sherlock', 'Vesa', 'Xiahou'],
            "3": ['Inosuke', 'Rosa', 'Saja'],
            "4": ['Drake', 'Heart Watcher', 'Natasha'],
       },
    },
    "Elyvia": {
        "faction": "Forest",
        "class": "Priest",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Garuda', 'Valkyrie', 'Vesa'],
            "2": ['Flora', 'Tussilago', 'Faceless'],
            "3": ['Sherlock', 'Michelle', 'Starlight'],
            "4": ['Rogan', 'Valentino', 'Waldeck'],
       },
    },
    "Garuda": {
        "faction": "Forest",
        "class": "Warrior",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Morax', 'Vesa', 'Oberon'],
            "2": ['UniMax-3000', 'Demon Hunter', 'Dragon Slayer'],
            "3": ['Gloria', 'Valkyrie', 'Groo'],
            "4": ['Rogan', 'Starlight', 'Faith Blade'],
       },
    },
    "Oberon": {
        "faction": "Forest",
        "class": "Mage",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
    },
    "Valkyrie": {
        "faction": "Forest",
        "class": "Ranger",
        "stars": [5, 6, 9, 10],
        "elite": false,
        "imprint": true,
    },
    "Heart Watcher": {
        "faction": "Forest",
        "class": "Assassin",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": false,
    },
    "Vesa": {
        "faction": "Forest",
        "class": "Priest",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
    },
    "Eddga": {
        "faction": "Forest",
        "class": "Warrior",
        "stars": [5, 6, 9, 10],
        "elite": false,
        "imprint": false,
    },
    "Rosa": {
        "faction": "Forest",
        "class": "Priest",
        "stars": [5, 6, 9, 10],
        "elite": false,
        "imprint": false,
    },
    "Malassa": {
        "faction": "Forest",
        "class": "Ranger",
        "stars": [5, 6, 9, 10],
        "elite": false,
        "imprint": false,
    },
    "Groo": {
        "faction": "Forest",
        "class": "Warrior",
        "stars": [5, 6, 9, 10],
        "elite": false,
        "imprint": false,
    },
    "Starlight": {
        "faction": "Forest",
        "class": "Mage",
        "stars": [5, 6, 9, 10],
        "elite": false,
        "imprint": false,
    },
    "Faceless": {
        "faction": "Forest",
        "class": "Assassin",
        "stars": [5, 6, 9, 10],
        "elite": false,
        "imprint": false,
    },
    "Dragon Slayer": {
        "faction": "Forest",
        "class": "Warrior",
        "stars": [5, 6, 9, 10],
        "elite": false,
        "imprint": false,
    },
    "Demon Hunter": {
        "faction": "Forest",
        "class": "Ranger",
        "stars": [5, 6, 9, 10],
        "elite": false,
        "imprint": false,
    },
    "The Grey-eyed": {
        "faction": "Forest",
        "class": "Assassin",
        "stars": [4, 5, 6, 9],
        "elite": false,
        "imprint": false,
    },
    "Zekkis": {
        "faction": "Forest",
        "class": "Priest",
        "class_supplement": "Mage",
        "stars": [4, 5, 6, 9],
        "elite": false,
        "imprint": false,
    },
    "Thale": {
        "faction": "Forest",
        "class": "Priest",
        "class_supplement": "Mage",
        "stars": [4, 5, 6, 9],
        "elite": false,
        "imprint": false,
    },
    "Kargath": {
        "faction": "Forest",
        "class": "Warrior",
        "stars": [4, 5],
        "elite": false,
        "imprint": false,
    },
    "Headstriker": {
        "faction": "Forest",
        "class": "Assassin",
        "stars": [4, 5],
        "elite": false,
        "imprint": false,
    },
    "Ent Elder": {
        "faction": "Forest",
        "class": "Priest",
        "class_supplement": "Mage",
        "stars": [4, 5],
        "elite": false,
        "imprint": false,
    },
    "Chief": {
        "faction": "Forest",
        "class": "Warrior",
        "stars": [4, 5],
        "elite": false,
        "imprint": false,
    },
    "Wind Walker": {
        "faction": "Forest",
        "class": "Ranger",
        "stars": [4, 5],
        "elite": false,
        "imprint": false,
    },
    /* === Dark ============================================================================================= */
    "Vespera": {
        "faction": "Dark",
        "class": "Priest",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Melissa', 'Aranea'],
            "2": ['Norton Haig', 'Patricia', 'Ignacia'],
            "3": ['Monkey King - Sun Wukong'],
            "4": ['Gaggie']
        },
    },
    "Alikita": {
        "faction": "Dark",
        "class": "Mage",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
             "1": ['Betty', 'Holmes Young', 'Norton Haig'],
             "2": ['Mockman', 'Annabelle', 'Monkey King - Sun Wukong'],
             "3": ['Aranea', 'Sylvie'],
             "4": ['Eos', 'Vespera'],
        },
    },
    "Patricia": {
        "faction": "Dark",
        "class": "Ranger",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
             "1": ['Natalie', 'Freya', 'Williams'],
             "2": ['Yorhm Tum', 'Waldeck', 'Norton Haig'],
             "3": ['Flora', 'Monkey King - Sun Wukong'],
             "4": ['Aranea', 'Finn'],
        },
    },
    "Elena": {
        "faction": "Dark",
        "class": "Priest",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
             "1": ['Aranea', 'Carrie', 'Betty'],
             "2": ['Drake', 'Gloria', 'Alikita'],
             "3": ['Mockman', 'Fiona', 'Luna'],
             "4": ['Phorcys', 'Amen-Ra', 'Yorhm Tum'],
        },
    },
    "Mockman": {
        "faction": "Dark",
        "class": "Warrior",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
             "1": ['Drake', 'Onkirimaru', 'Azrael'],
             "2": ['Garuda', 'Freya', 'Elena'],
             "3": ['Phorcys', 'Carrie', 'Aylamak'],
             "4": ['Xiahou', 'Amen-Ra', 'Gaggie'],
        },
    },
    "Phorcys": {
        "faction": "Dark",
        "class": "Mage",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Carrie', 'Horus', 'Onkirimaru'],
            "2": ['Gloria', 'Mihm', 'Mockman'],
            "3": ['Delacium', 'Amen-Ra', 'Elena'],
            "4": ['Inosuke', 'Karim', 'Vulkan'],
       },
    },
    "Drake": {
        "faction": "Dark",
        "class": "Assassin",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Phorcys', 'Amuvor', 'Das Moge'],
            "2": ['Garuda', 'Sleepless', 'Xiahou'],
            "3": ['Carrie', 'Amen-Ra', 'Annabelle'],
            "4": ['Ignis', 'Kamath', 'Natasha'],
       },
    },
    "Carrie": {
        "faction": "Dark",
        "class": "Ranger",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Gustin', 'Mihm', 'Morax'],
            "2": ['Phorcys', 'Das Moge', 'Walter'],
            "3": ['Amuvor', 'Ithaqua', 'Lutz'],
            "4": ['Tix', 'Amen-Ra', 'Onkirimaru'],
       },
    },
    "Amen-Ra": {
        "faction": "Dark",
        "class": "Priest",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Aspen', 'Walter', 'Lord Balrog'],
            "2": ['Horus', 'Dark Arthindol', 'Blood Blade'],
            "3": ['Eloise', 'Das Moge', 'Dominator'],
            "4": ['Gustin', 'Jahra', 'Lutz'],
       },
    },
    "Aspen": {
        "faction": "Dark",
        "class": "Warrior",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Horus', 'Eddga', 'Lord Balrog'],
            "2": ['Aspen', 'Dark Arthindol', 'Groo'],
            "3": ['Baade', 'Asmodel', 'Walter'],
            "4": ['Blood Blade', 'Sleepless', 'Skerei'],
       },
    },
    "Mihm": {
        "faction": "Dark",
        "class": "Mage",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Horus', 'Corpsedemon', 'Kharma'],
            "2": ['Aspen', 'Field', 'Dominator'],
            "3": ['Carrie', 'Valentino', 'Dark Arthindol'],
            "4": ['Flora', 'Aidan', 'Sleepless'],
       },
    },
    "Amuvor": {
        "faction": "Dark",
        "class": "Assassin",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
    },
    "Das Moge": {
        "faction": "Dark",
        "class": "Ranger",
        "stars": [5, 6, 9, 10],
        "elite": false,
        "imprint": true,
    },
    "Sleepless": {
        "faction": "Dark",
        "class": "Warrior",
        "stars": [5, 6, 9, 10],
        "elite": false,
        "imprint": true,
    },
    "Dark Arthindol": {
        "faction": "Dark",
        "class": "Mage",
        "stars": [5, 6, 9, 10],
        "elite": false,
        "imprint": true,
    },
    "Dark Spirit": {
        "faction": "Dark",
        "class": "Mage",
        "stars": [4, 5, 6, 9],
        "elite": false,
        "imprint": false,
    },
    "Logan": {
        "faction": "Dark",
        "class": "Mage",
        "stars": [4, 5],
        "elite": false,
        "imprint": false,
    },
    "Darkness Fanella": {
        "faction": "Dark",
        "class": "Mage",
        "stars": [4, 5],
        "elite": false,
        "imprint": false,
    },
    /* === Light heroes ============================================================================================= */
    "Monkey King - Sun Wukong": {
        "faction": "Light",
        "class": "Warrior",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
             "1": ['Gaggie', 'Onkirimaru', 'Basilisk'],
             "2": ['Melissa', 'Natasha', 'Finn'],
             "3": ['Sherlock'],
             "4": ['Saja'],
        },
    },
    "Yorhm Tum": {
        "faction": "Light",
        "class": "Assassin",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Geester', 'Azrael'],
            "2": ['Freya', 'Tussilago', 'Williams'],
            "3": ['Betty', 'Norton Haig'],
            "4": ['Drake', 'Monkey King - Sun Wukong'],
       },
    }, 
    "Natalie": {
        "faction": "Light",
        "class": "Ranger",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Eos', 'Geester', 'Patricia'],
            "2": ['Vulkan', 'Yorhm Tum'],
            "3": ['Elena', 'Betty'],
            "4": ['Freya', 'Luna'],
       },
    },
    "Vulkan": {
        "faction": "Light",
        "class": "Warrior",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Eos', 'Morax', 'Aylamak'],
            "2": ['Tussilago', 'Onkirimaru', 'Natalie'],
            "3": ['Andrea', 'Mockman', 'Gaggie'],
            "4": ['Xiahou', 'Freya', 'Patricia'],
       },
    },
    "Eos": {
        "faction": "Light",
        "class": "Mage",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Belrain', 'Gloria', 'Holmes Young'],
            "2": ['Andrea', 'Phorcys', 'Vulkan'],
            "3": ['Tussilago', 'Natasha', 'Aylamak'],
            "4": ['Russell', 'Annabelle', 'Natalie'],
       },
    },
    "Andrea": {
        "faction": "Light",
        "class": "Priest",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Fiona', 'Belrain', 'Eos'],
            "2": ['Flora', 'Aida', 'Holmes Young'],
            "3": ['Russell', 'Asmodel', 'Vulkan'],
            "4": ['Ignis', 'Michelle', 'Aranea'],
       },
    },
    "Tussilago": {
        "faction": "Light",
        "class": "Assassin",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Andrea', 'Aida', 'Saja'],
            "2": ['Inosuke', 'Tara', 'Eos'],
            "3": ['Drake', 'Russell', 'Azrael'],
            "4": ['Rogan', 'Rosa', 'Natalie'],
       },
    },
    "Russell": {
        "faction": "Light",
        "class": "Ranger",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Andrea', 'Tara', 'Starlight'],
            "2": ['Aida', 'Faith Blade', 'Xiahou'],
            "3": ['Tussilago', 'Gerke', 'Saja'],
            "4": ['Sherlock', 'Demon Hunter', 'Eos'],
       },
    },
    "Tara": {
        "faction": "Light",
        "class": "Warrior",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Belrain', 'Andrea', 'Faith Blade'],
            "2": ['Michelle', 'OD-01', 'Gerke'],
            "3": ['Asmodel', 'Sleepless', 'Iceblink'],
            "4": ['Tussilago', 'Malassa', 'Oberon'],
       },
    },
    "Aida": {
        "faction": "Light",
        "class": "Mage",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Rosa', 'Bleecker', 'Flame Strike'],
            "2": ['Belrain', 'Tara', 'Fat Mu'],
            "3": ['Michelle', 'Miki', 'Sigmund'],
            "4": ['Field', 'Eddga', 'Xia'],
       },
    },
    "Belrain": {
        "faction": "Light",
        "class": "Priest",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Aida', 'Mirage', 'Vesa'],
            "2": ['Tara', 'Miki', 'Michelle'],
            "3": ['Russell', 'Andrea', 'Ormus'],
            "4": ['Tussilago', 'Honor Guard', 'Valentino'],
       },
    },
    "Faith Blade": {
        "faction": "Light",
        "class": "Assassin",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Russell', 'Miki', 'Mirage'],
            "2": ['Belrain', 'Fat Mu', 'Ormus'],
            "3": ['Aida', 'Rosa', 'Field'],
            "4": ['Das Moge', 'Starlight', 'Faith Blade'],
       },
    },
    "Michelle": {
        "faction": "Light",
        "class": "Ranger",
        "stars": [5, 6, 9, 10],
        "elite": false,
        "imprint": true,
    },
    "Asmodel": {
        "faction": "Light",
        "class": "Warrior",
        "stars": [5, 6, 9, 10],
        "elite": false,
        "imprint": true,
    },
    "Gerke": {
        "faction": "Light",
        "class": "Priest",
        "stars": [5, 6, 9, 10],
        "elite": false,
        "imprint": true,
    },
    "Divine Spirit": {
        "faction": "Light",
        "class": "Mage",
        "stars": [4, 5, 6, 9],
        "elite": false,
        "imprint": false,
    },
    "Fegan": {
        "faction": "Light",
        "class": "Warrior",
        "stars": [4, 5],
        "elite": false,
        "imprint": false,
    },
    "Disciple": {
        "faction": "Light",
        "class": "Priest",
        "stars": [4, 5],
        "elite": false,
        "imprint": false,
    }, 
    /* === Transcendence ============================================================================================= */
    "Star-devouring Bloom - Madeleine": {
        "faction": "Transcendence",
        "class": "Priest",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Madeleine', 'Ignacia'],
            "2": ['Count of Nightmare - Finn', 'Sylvie',],
            "3": ['Finn',],
            "4": ['Ironcore Mecha - Basilisk',],
        },
        "short": "BDSM",
    },
    "Ironcore Mecha - Basilisk": {
        "faction": "Transcendence",
        "class": "Ranger",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Basilisk', 'Monkey King - Sun Wukong'],
            "2": ['Great Sage - Sun Wukong', 'Williams',],
            "3": ['Finn',],
            "4": ['Cosmic Enforcer - Luna',],
        },
        "short": "IMB",
    },
    "Weaver of Life - Ignacia": {
        "faction": "Transcendence",
        "class": "Mage",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Ignacia', 'Melissa'],
            "2": ['Roseheart Fanatic - Williams', 'Natalie',],
            "3": ['Williams',],
            "4": ['Count of Nightmare - Finn',],
        },
        "short": "WIFE",
    },
    "Stygian Twilight - Vespera": {
        "faction": "Transcendence",
        "class": "Priest",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
             "1": ['Vespera', 'Norton Haig'],
             "2": ['Therapist of Blood - Betty', 'Freya', 'Star-devouring Bloom - Madeleine'],
             "3": ['Betty'],
             "4": ['Roseheart Fanatic - Williams'],
        },
        "short": "STV",
    },
    "Cosmic Speedster - Sylvie": {
        "faction": "Transcendence",
        "class": "Warrior",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
             "1": ['Sylvie', 'Alikita'],
             "2": ['Lady of Blossom Realm - Melissa', 'Luna'],
             "3": ['Melissa'],
             "4": ['King of Abysmal Sea - Norton Haig'],
        },
        "short": "CSS",
    },
    "Count of Nightmare - Finn": {
        "faction": "Transcendence",
        "class": "Assassin",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
             "1": ['Finn', 'Williams'],
             "2": ['Mutated Fungus - Geester', 'Natalie', 'Ironcore Mecha - Basilisk'],
             "3": ['Geester'],
             "4": ['Cosmic Enforcer - Luna'],
        },
        "short": "CNF",
    },
    "Great Sage - Sun Wukong": {
        "faction": "Transcendence",
        "class": "Warrior",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
             "1": ['Monkey King - Sun Wukong', 'Luna'],
             "2": ['Lord of Death - Azrael', 'Alikita', 'Weaver of Life - Ignacia'],
             "3": ['Azrael'],
             "4": ['Lord of Sparkles - Yorhm Tum'],
        },
        "short": "GSSW",
    },
    "King of Abysmal Sea - Norton Haig": {
        "faction": "Transcendence",
        "class": "Warrior",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
             "1": ['Norton Haig', 'Yorhm Tum'],
             "2": ['Asmodel the Dauntless', 'Melissa', 'Stygian Twilight - Vespera'],
             "3": ['Asmodel'],
             "4": ['Star Wing - Jahra'],
        },
        "short": "KANH",
    },
    "Roseheart Fanatic - Williams": {
        "faction": "Transcendence",
        "class": "Ranger",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
             "1": ['Williams', 'Geester'],
             "2": ['Interstellar Hunteress - Patricia', 'Aranea', 'Cosmic Speedster - Sylvie'],
             "3": ['Patricia'],
             "4": ['Asmodel the Dauntless', 'Star-devouring Bloom - Madeleine'],
        },
        "short": "RFW",
    },
    "Lady of Blossom Realm - Melissa": {
        "faction": "Transcendence",
        "class": "Ranger",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
             "1": ['Melissa', 'Annabelle'],
             "2": ['Phantom Defier - Elena', 'Waldeck', 'Count of Nightmare - Finn'],
             "3": ['Elena'],
             "4": ['Fairy Queen - Vesa'],
        },
        "short": "LBRM",
    },
    "Infinite Era - Alikita": {
        "faction": "Transcendence",
        "class": "Mage",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
             "1": ['Alikita', 'Freya'],
             "2": ['Therapist of Blood - Betty', 'Azrael', 'Great Sage - Sun Wukong'],
             "3": ['Betty'],
             "4": ['Bloodtide Queen - Aranea', 'Ironcore Mecha - Basilisk'],
        },
        "short": "IEA",
    },
    "Cosmic Enforcer - Luna": {
        "faction": "Transcendence",
        "class": "Assassin",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
             "1": ['Luna', 'Natalie'],
             "2": ['Lord of Sparkles - Yorhm Tum', 'Gaggie', 'Roseheart Fanatic - Williams'],
             "3": ['Yorhm Tum'],
             "4": ['Therapist of Blood - Betty', 'Stygian Twilight - Vespera'],
        },
        "short": "CEL",
    },
    "Interstellar Hunteress - Patricia": {
        "faction": "Transcendence",
        "class": "Ranger",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
             "1": ['Patricia', 'Gaggie'],
             "2": ['Doppelganger - Natalia', 'Yorhm Tum', 'King of Abysmal Sea - Norton Haig'],
             "3": ['Natalie'],
             "4": ['Hypperspace Hunter - Aylamak', 'Cosmic Speedster - Sylvie', 'Weaver of Life - Ignacia'],
        },
        "short": "IHP",
    },
    "Lord of Sparkles - Yorhm Tum": {
        "faction": "Transcendence",
        "class": "Assassin",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
             "1": ['Yorhm Tum', 'Freya'],
             "2": ['Mutated Fungus - Geester', 'Aylamak', 'Lady of Blossom Realm - Melissa'],
             "3": ['Geester'],
             "4": ['Doppelganger - Natalia', 'Infinite Era - Alikita', 'Count of Nightmare - Finn'],
        },
        "short": "LSYT",
    },
    "Chaosbound Spirit - Gaggie": {
        "faction": "Transcendence",
        "class": "Warrior",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
             "1": ['Gaggie', 'Betty'],
             "2": ['Star Wing - Jahra', 'Freya', 'Infinite Era - Alikita'],
             "3": ['Aylamak'],
             "4": ['Hypperspace Hunter - Aylamak', 'Vulkan', 'Great Sage - Sun Wukong'],
        },
        "short": "CSG",
    },
    "Therapist of Blood - Betty": {
        "faction": "Transcendence",
        "class": "Mage",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
             "1": ['Betty', 'Geester'],
             "2": ['Lord of Death - Azrael', 'Elena', 'Interstellar Hunteress - Patricia'],
             "3": ['Azrael', 'Yorhm Tum'],
             "4": ['Bloodtide Queen - Aranea', 'Natalie', 'Roseheart Fanatic - Williams'],
        },
        "short": "TBB",
    }, 
    "Doppelganger - Natalia": {
        "faction": "Transcendence",
        "class": "Ranger",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
             "1": ['Natalie', 'Mockman'],
             "2": ['Mutated Fungus - Geester', 'Betty', 'Cosmic Enforcer - Luna'],
             "3": ['Eos', 'Aylamak'],
             "4": ['Doom Terminator - Vulkan', 'Lady of Blossom Realm - Melissa', 'Chaosbound Spirit - Gaggie'],
        },
        "short": "DGN",
    },
    "Mutated Fungus - Geester": {
        "faction": "Transcendence",
        "class": "Assassin",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
             "1": ['Geester', 'Natalie'],
             "2": ['Lord of Death - Azrael', 'Vulkan', 'Chaosbound Spirit - Gaggie'],
             "3": ['Azrael', 'Gaggie'],
             "4": ['Phantom Defier - Elena', 'Lord of Sparkles - Yorhm Tum', 'King of Abysmal Sea - Norton Haig'],
        },
        "short": "MFG",
    },
    "Hypperspace Hunter - Aylamak": {
        "faction": "Transcendence",
        "class": "Warrior",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
             "1": ['Aylamak', 'Saja'],
             "2": ['Star Alchemist - Holmes Young', 'Vulkan', 'Lord of Sparkles - Yorhm Tum'],
             "3": ['Fiona', 'Geester'],
             "4": ['Sword Flash - Xia', 'Elena', 'Cosmic Enforcer - Luna'],
        },
        "short": "HHA",
    },
    "Phantom Defier - Elena": {
        "faction": "Transcendence",
        "class": "Priest",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
             "1": ['Elena', 'Mockman'],
             "2": ['Lord of Fear - Aspen', 'Aranea', 'Betty'],
             "3": ['Vulkan', 'Annabelle'],
             "4": ['Fairy Queen - Vesa', 'Azrael', 'Interstellar Hunteress - Patricia'],
        },
        "short": "PDE",
    },
    "Doom Terminator - Vulkan": {
        "faction": "Transcendence",
        "class": "Warrior",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
             "1": ['Vulkan', 'Mockman'],
             "2": ['The Sun Devourer - Eos', 'Andrea', 'Mutated Fungus - Geester'],
             "3": ['Azrael', 'Tussilago'],
             "4": ['Asmodel the Dauntless', 'Aranea', 'Doppelganger - Natalia'],
        },
        "short": "DTV",
    },
    "Bloodtide Queen - Aranea": {
        "faction": "Transcendence",
        "class": "Priest",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
             "1": ['Aranea', 'Natasha'],
             "2": ['Fairy Queen - Vesa', 'Azrael', 'Phantom Defier - Elena'],
             "3": ['Freya', 'Annabelle'],
             "4": ['Scarlet Queen - Halora', 'Elena', 'Therapist of Blood - Betty'],
        },
        "short": "BQA",
    },
    "Lord of Death - Azrael": {
        "faction": "Transcendence",
        "class": "Assassin",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
             "1": ['Azrael', 'Eloise'],
             "2": ['Sword Flash - Xia', 'Annabelle', 'Doom Terminator - Vulkan'],
             "3": ['Natasha', 'Holmes Young'],
             "4": ['Mystic Fairy - Freya', 'Aranea', 'Mutated Fungus - Geester'],
        },
        "short": "LDA",
    },
    "Star Swordsman - Mockman": {
        "faction": "Transcendence",
        "class": "Warrior",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
             "1": ['Mockman', 'Phorcys'],
             "2": ['Sword Flash - Xia', 'Onkirimaru', 'Bloodtide Queen - Aranea'],
             "3": ['Eloise', 'Freya'],
             "4": ['Star Wing - Jahra', 'Saja', 'Hypperspace Hunter - Aylamak'],
        },
        "short": "SSM",
    },
    "Mystic Fairy - Freya": {
        "faction": "Transcendence",
        "class": "Ranger",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
             "1": ['Freya', 'Annabelle'],
             "2": ['Fairy Queen - Vesa', 'Waldeck', 'Lord of Death - Azrael'],
             "3": ['Xiahou', 'Gloria'],
             "4": ['Asmodel the Dauntless', 'Eos', 'Doppelganger - Natalia'],
        },
        "short": "MFF",
    },
    "Star Alchemist - Holmes Young": {
        "faction": "Transcendence",
        "class": "Mage",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
             "1": ['Holmes Young', 'Xiahou'],
             "2": ['Sword Flash - Xia', 'Annabelle', 'Star Swordsman - Mockman'],
             "3": ['Saja', 'Eos'],
             "4": ['The Sun Devourer - Eos', 'Azrael', 'Hypperspace Hunter - Aylamak'],
        },
        "short": "SAHY",
    },
    "The Sun Devourer - Eos": {
        "faction": "Transcendence",
        "class": "Mage",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Eos', 'Russell'],
            "2": ['Fairy Queen - Vesa', 'Annabelle', 'Star Alchemist - Holmes Young'],
            "3": ['Xiahou', 'Natasha'],
            "4": ['Lord of Fear - Aspen', 'Vulkan', 'Doom Terminator - Vulkan'],
       },
       "short": "SDE",
    },
    "Lord of Fear - Aspen": {
        "faction": "Transcendence",
        "class": "Warrior",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Aspen', 'Drake'],
            "2": ['Scarlet Queen - Halora', 'Carrie', 'Star Swordsman - Mockman'],
            "3": ['Onkirimaru', 'Amen-Ra'],
            "4": ['Asmodel the Dauntless', 'Mockman', 'Phantom Defier - Elena'],
       },
       "short": "LFA",
    },
    "Fairy Queen - Vesa": {
        "faction": "Transcendence",
        "class": "Priest",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Vesa', 'Rogan'],
            "2": ['Sword Flash - Xia', 'Xiahou', 'Mystic Fairy - Freya'],
            "3": ['Flora', 'Aranea'],
            "4": ['Star Wing - Jahra', 'Freya', 'Bloodtide Queen - Aranea'],
       },
       "short": "FQV",
    },
    "Star Wing - Jahra": {
        "faction": "Transcendence",
        "class": "Mage",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Jahra', 'Ithaqua'],
            "2": ['Scarlet Queen - Halora', 'Tix', 'Star Alchemist - Holmes Young'],
            "3": ['Eloise', 'Annabelle'],
            "4": ['Sword Flash - Xia', 'Holmes Young', 'Phantom Defier - Elena'],
       },
       "short": "SWJ",
    },
    "Asmodel the Dauntless": {
        "faction": "Transcendence",
        "class": "Warrior",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Asmodel', 'Andrea'],
            "2": ['Star Wing - Jahra', 'Russell', 'The Sun Devourer - Eos'],
            "3": ['Tussilago', 'Saja'],
            "4": ['Scarlet Queen - Halora', 'Eos', 'Doom Terminator - Vulkan'],
       },
       "short": "ATD",
    },
    "Scarlet Queen - Halora": {
        "faction": "Transcendence",
        "class": "Ranger",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Queen', 'Ignis'],
            "2": ['Asmodel the Dauntless', 'Waldeck', 'Mystic Fairy - Freya'],
            "3": ['Gloria', 'Morax'],
            "4": ['Star Wing - Jahra', 'Delacium', 'Bloodtide Queen - Aranea'],
       },
       "short": "SQH",
    },
    "Sword Flash - Xia": {
        "faction": "Transcendence",
        "class": "Assassin",
        "stars": [5, 6, 9, 10],
        "elite": true,
        "imprint": true,
        "tenants": {
            "1": ['Xia', 'Fiona'],
            "2": ['Scarlet Queen - Halora', 'Sherlock', 'Lord of Fear - Aspen'],
            "3": ['Onkirimaru', 'Inosuke'],
            "4": ['Asmodel the Dauntless', 'Gloria', 'Lord of Death - Azrael'],
       },
       "short": "SFX",
    },
}

let tenants = new Set<string>();

Object.values(_heroesData).forEach((hero_data) => {
    if (hero_data.tenants) {
        Object.values(hero_data.tenants).forEach((_tenants) => {
            _tenants.forEach(name => {
                tenants.add(name);
            })
        })
    }
});
Object.keys(_heroesData).forEach(hero => _heroesData[hero].tenant = tenants.has(hero))

export const heroesData: HeroesData = _heroesData;
